import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARTER_SAP_AI_PROMPT = createFcmDetails('starter_sap_ai_prompt', {
	owner: 'starfish',
	context: 'Start A Petition Page',
	import: false,
	description:
		'Configuration for SAP AI Prompt step: isEnabled determines whether the AI step is enabled for users. If it is enabled, systemPrompt specifies the output format that ChatGPT should return and prompt is an array that will determine what will be sent to the OpenAI API call. Each object in the array contains a "replacer" which is the petition variable we will replace in the "text" field. The "filter" field corresponds to the name of the value passed from the code in the SAP flow.',
	template: {
		isEnabled: true,
		systemPrompt:
			'You write petitions for Change.org users using their input. A Change.org petition is built with one title (less than 90 characters, starts with a verb) and one description (ends with a call to sign the petition). You will always reply with one petition title, and one petition description (nothing before, nothing after).',
		prompt: [
			{
				filter: 'mainPrompt',
				replacer: 'mainPrompt',
				text: 'Write a petition in the style of Change.org to %{mainPrompt}. Do not start the petition with "we, the undersigned". Support the petition with relevant facts and statistics, but only if they are correct and you have good confidence in them. Cite your sources, but do not try to provide links in your response.',
			},
			{
				filter: 'locationName',
				replacer: 'location',
				text: 'The petition will be relevant for people in %{location}.',
			},
			{
				filter: 'personalStory',
				replacer: 'personalStory',
				text: 'This petition is personal to the creator because %{personalStory}. Start the petition with the personal story.',
			},
		],
	},
});
